import {Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faStar, faTimes} from "@fortawesome/free-solid-svg-icons";
import {useBoundStore} from "../../../Store/store";
import toast from "react-hot-toast";
import * as React from "react";
import {useTranslation} from "react-i18next";

export const ScoreDialog = (props) => {
    const {
        isOpen,
        onClose,
        performanceStatementId,
        onSuccess
    } = props;

    const {t} = useTranslation();
    const acceptPerformanceStatement = useBoundStore((state) => state.acceptPerformanceStatement);

    const items = [
        {
            number: 1
        },
        {
            number: 2
        },
        {
            number: 3
        },
        {
            number: 4
        },
        {
            number: 5
        }
    ];

    const handleStarClick = (index) => {
        const ratingGiven = 5-index;
        acceptPerformanceStatement(performanceStatementId, {rating: ratingGiven})
            .then(() => {
                onClose();
                toast.success(t('performance_reports.toast_accepted'));
                if (onSuccess) {
                    onSuccess();
                }
            })
    }

    return (
        <Dialog open={isOpen} onClose={() => onClose()} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300 ease-in-out data-[closed]:opacity-0"
            />
            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel className="max-w-lg space-y-4 border bg-white p-12">
                    <div className="flex items-start justify-between">
                        <DialogTitle className="font-bold text-center">Accepteer prestatierapport</DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                            <button
                                type="button"
                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                                onClick={() => onClose()}
                            >
                                <span className="absolute -inset-2.5"/>
                                <span className="sr-only">Close panel</span>
                                <FontAwesomeIcon icon={faTimes} className="h-6 w-6" aria-hidden="true"/>
                            </button>
                        </div>
                    </div>
                    <Description>{t('performance_reports.score_title')}</Description>

                    <div className="flex flex-row-reverse justify-center gap-1">
                        {items.map((item, index) => (
                            <div
                                className={'text-gray-700 [&:hover~*]:text-gold hover:text-gold text-5xl duration-500 transition-all cursor-pointer'}
                                onClick={() => handleStarClick(index)} key={index}>
                                <FontAwesomeIcon icon={faStar}/>
                            </div>
                        ))}
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    )
}